import './plugins/docReady';
import 'lazysizes';

import './plugins/mobileMenu';

import 'owl.carousel/dist/owl.carousel.min';
import 'owl.carousel/dist/assets/owl.carousel.min.css';
import 'owl.carousel/dist/assets/owl.theme.default.min.css';

import {initRecaptcha} from "./plugins/recaptcha";

import './plugins/formValidation/formValidation.css';
import './plugins/formValidation/formValidation';

import './plugins/countdown';

import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';

import 'cookie-notice/dist/cookie.notice.min';

// import utilsScripts from 'utils-scripts';

const _dir = $('html').attr('dir');
const _isRtl = (_dir === 'rtl');

$.fn.isInViewport = function () {
    const elementTop = $(this).offset().top;
    const elementBottom = elementTop + $(this).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};


((
    ($) => {
        $(".owl-main").owlCarousel({
            rtl: _isRtl,
            margin: 0,
            items: 1,
            dots: true,
            autoplay: false,
            loop: true,
            autoplayTimeout: 5000,
            animateIn: 'fadeIn',
            animateOut: 'fadeOut',
            onInitialized: function (event) {
                const element = event.target;
                $(element).closest('.loading').removeClass('loading');

                const _video = $(element).find('.owl-item.active .item .item1--video');
                if (_video) {
                    const _iframe = _video.find('> iframe');
                    _iframe.attr('src', _iframe.data('src'));
                    _video.addClass('active');
                }

                $(element).find('.owl-dot').each(function (index, element) {
                    if (element.tagName.toLowerCase() === 'button') {
                        $(element).attr('aria-label', 'Slide #' + ++index);
                    }
                });
            },
            onTranslate: function (event) {
                const element = event.target;
                const _last_video = $(element).find('.owl-item .item1--video.active');
                if (_last_video) {
                    const _iframe = _last_video.find('> iframe');
                    _iframe.removeAttr('src');
                    _last_video.removeClass('active');
                }
            },
            onTranslated: function (event) {
                const element = event.target;
                const _video = $(element).find('.owl-item.active .item1--video');
                if (_video) {
                    const _iframe = _video.find('> iframe');
                    _iframe.attr('src', _iframe.data('src'));
                    _video.addClass('active');
                }
            }
        });

        const header = $(".header");

        const _sticky_logo = window.application.stick_logo;
        const _logo = window.application.logo;

        function stickyMenu() {
            if ($(window).width() > 575) {
                if ($(window).scrollTop() > 1) {
                    header.addClass("sticky");
                    $('#header-logo').find('> img').attr('src', _sticky_logo);
                } else {
                    header.removeClass("sticky");
                    $('#header-logo').find('> img').attr('src', _logo);
                }
            }
        }

        stickyMenu();

        const UpBtn = $('#upBtn');

        function toTop() {
            if ($(window).scrollTop() > 300) {
                UpBtn.addClass('show');
            } else {
                UpBtn.removeClass('show');
            }
        }

        UpBtn.on('click', function (e) {
            e.preventDefault();
            $('html, body').stop().animate({scrollTop: 0}, 300);
        });

        $(window).on('scroll', function () {
            toTop();
            stickyMenu();
        });

        toTop();

        new cookieNoticeJS({
            'cookieNoticePosition': 'top',
            'expiresIn': 30,
            'fontFamily': "'Raleway', 'sans-serif'",
            'fontSize': '12px',
            'buttonBgColor': '#ffffff',
            'buttonTextColor': '#f06b55',
            'noticeBgColor': '#f06b55',
            'noticeTextColor': '#fff',
        });
    }
)
(jQuery));

document.addEventListener('lazybeforeunveil', function (e) {
    const bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});

docReady(() => {

    const _forms = $('.validate-form')

    let _options = {
        checkRequired: true,
        scrollToFirstError: false,
        showErrorGeneralMsg: false,
        requiredMsg: application.translations.required_field,
        emailValidationMsg: 'Invalid email address!',
    };

    if (_forms.attr('data-remove-form')) {
        _options.beforeSuccessStartsCallBack = removeForm;
    }

    function removeForm(_form, response) {
        if (typeof response.message !== 'undefined' && response.message.length > 0) {
            _form.parent().html('<div class="alert alert-success">' + response.message + '</div>');
        }
    }

    _forms.validateForm(_options);

    const _loadFormCaptcha = function (_form) {
        let _captcha = _form.find('.g-recaptcha');
        if (_captcha.length && typeof grecaptcha !== 'undefined') {
            if (typeof _captcha.attr('data-id') === 'undefined') {
                setTimeout(function () {
                    let widgetId = grecaptcha.render(_captcha[0], {
                        'sitekey': window.application.services.gcaptcha.site_key
                    });
                    _captcha.attr('data-id', widgetId);
                }, 1000);
            }
        }
    };

    const inputs = $('.phone').first();
    let iti = '';
    if (inputs.length) {
        iti = intlTelInput(inputs[0], {
            utilsScript: window.application.utils_url,
            // nationalMode: true,
            initialCountry: "auto",
            geoIpLookup: function (success, failure) {
                $.get("https://ipinfo.io", function () {
                }, "jsonp").always(function (resp) {
                    var countryCode = (resp && resp.country) ? resp.country : "us";
                    success(countryCode);
                });
            },
        });
    }

    inputs.on('change', function () {
        inputs.val(iti.getNumber());
    });
    // const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

    // if (inputs.val().trim()) {
    //     const _wrapper = inputs.closest('.form-group-wrapper');
    //     if (iti.isValidNumber()) {
    //         _wrapper.removeClass('has-error');
    //         _wrapper.find('.legp-formz-error').remove()
    //     } else {
    //         _wrapper.addClass('has-error');
    //         const errorWrapper = $(`<div class="legp-formz-error help-block help-block-error form-control-feedback lego-formz-input-error"></div>`);
    //
    //         var errorCode = iti.getValidationError();
    //         if (typeof errorMap[errorCode] != "undefined") {
    //             $(errorWrapper).html(errorMap[errorCode]);
    //
    //         } else {
    //             errorWrapper.text('Invalid Input');
    //         }
    //         console.log(errorWrapper.text());
    //         _wrapper.append(errorWrapper);
    //         // return;
    //     }
    // }

    $('form').each((_index, _form) => {
        _form = $(_form);
        _form.find('input, select, textarea').on('focus', function () {
            if (!_form.is(':visible')) {
                return;
            }
            initRecaptcha()
                .then(() => {
                    _loadFormCaptcha(_form);
                }).catch((err) => {
            });
        });
        _form.find('button[type="submit"]').on('click', function () {
            if (!_form.is(':visible')) {
                return;
            }
            initRecaptcha()
                .then(() => {
                    _loadFormCaptcha(_form);
                }).catch((err) => {
            });
        });
    });

    let targets = $('.js-lazyload');

    if (targets.length) {
        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 0
        };

        let observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if (!$(entry.target).hasClass('activated')) {
                        if ($(entry.target).hasClass('areas-lazyload')) {
                            $(".owl-areas").owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                items: 3,
                                dots: true,
                                loop: true,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');

                                    $(element).find('.owl-dot').each(function (index, element) {
                                        if (element.tagName.toLowerCase() === 'button') {
                                            $(element).attr('aria-label', 'Slide #' + ++index);
                                        }
                                    });
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    768: {
                                        items: 2,
                                    },
                                    1200: {
                                        items: 3,
                                    }
                                }
                            });
                        }
                        else if ($(entry.target).hasClass('partners-lazyload')) {
                            $('.owl-partners').owlCarousel({
                                rtl: _isRtl,
                                margin: 20,
                                dots: true,
                                loop: false,
                                items: 6,
                                autoplay: true,
                                slideTransition: 'ease',
                                autoplayTimeout: 3000,
                                autoplaySpeed: 1000,
                                onInitialized: function (event) {
                                    const element = event.target;
                                    $(element).closest('.lazyload-block').removeClass('lazyload-block');
                                    $(entry.target).addClass('activated');
                                },
                                responsive: {
                                    0: {
                                        items: 1,
                                    },
                                    330: {
                                        items: 2,
                                    },
                                    576: {
                                        items: 3,
                                    },
                                    700: {
                                        items: 4,
                                    },
                                    768: {
                                        items: 5,
                                    },
                                    1200: {
                                        items: 6,
                                    }
                                }
                            });
                        }
                    }
                }
            });
        }, options);

        targets.each(target => {
            observer.observe(targets[target]);
        });
    }
});